import DOMPurify from 'dompurify';

// Constants
import { StyledRichText } from './styles';

const RichText = ({ className, richText }: { className: string; richText: string }): any =>
  richText === '' ? null : (
    <StyledRichText className={className} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(richText) }} />
  );

export default RichText;
